import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import { ControlledInput } from "../../../common/Input/Input";
import ModalContent from "../../../common/Modal/ModalContent";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import moment from "moment";
import Select from "react-select";
import { X } from "react-feather";
import Spinner from "../../../common/Spinner/Spinner";
import { useEffect, useState } from "react";
import get from "lodash/get";
import pick from "lodash/pick";
import split from "lodash/split";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import UserProfileSupportedDataModal from "./UserProfileSupportedDataModal";
import UserProfileSupportedStatusHistoryDataModal from "./UserProfileSupportedStatusHistoryDataModal";
import UserProfileChangeEmailHistory from "./UserProfileChangeEmailHistory";
import axios from "axios";
import UserMetaChangeLogModal from "../Handholder/UserMetaChangeLogModal";
import ReactDatePicker from "react-datepicker";
import find from "lodash/find";
import Checkbox from "../../../common/Checkbox/Checkbox";

import { getServiceTypesMaster } from "../../../utils/localStorage";
import { identity, update } from "lodash";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import UserServiceFeedbackModal from "./UserServiceFeedbackModal";

Modal.setAppElement("#root");

const arrayUserProfileData=[
	{
	  "id": 1,
	  "sName": "IntroductoryCall",
	  "sDisplayText": "Introductory Call",
	  "sFieldType": "select",
	  "listValues": [
		{
		  "label": "Yes",
		  "value": "Yes"
		},
		{
		  "label": "No",
		  "value": "No"
		}
	  ],
	  "sQuestionnaireType": "User",
	  "bIsDependent": false,
	  "UserAnswer": null
	},
	{
	  "id": 2,
	  "sName": "CallConnectedStatus",
	  "sDisplayText": "Call Connected Status",
	  "sFieldType": "select",
	  "listValues": [
		{
		  "label": "Connected",
		  "value": "Connected"
		},
		{
		  "label": "Not Connected",
		  "value": "Not Connected"
		}
	  ],
	  "sQuestionnaireType": "User",
	  "bIsDependent": false,
	  "UserAnswer": null
	},
	{
	  "id": 3,
	  "sName": "EngagementCallStayEngaged",
	  "sDisplayText": "Engagement call - Stay Engaged",
	  "sFieldType": "select",
	  "listValues": [
		{
		  "label": "Yes",
		  "value": "Yes"
		},
		{
		  "label": "No",
		  "value": "No"
		}
	  ],
	  "sQuestionnaireType": "User",
	  "bIsDependent": true,
	  "UserAnswer": null,
	  "DependQuestions": [
		{
		  "id": 4,
		  "sName": "NotEngagementReason",
		  "sDisplayText": "Not Engagement Reason",
		  "sFieldType": "textbox",
		  "listValues": "",
		  "sQuestionnaireType": "User",
		  "bIsDependent": false,
		  "UserAnswer": null,
		  "sDependentAnswer":"No"
		},
		
	  ],
	  
	},
	{
	  "id": 5,
	  "sName": "DoesusersharedChallenges_Goal",
	  "sDisplayText": "Does user shared Challenges/Goal",
	  "sFieldType": "select",
	  "listValues": [
		{
		  "label": "Yes",
		  "value": "Yes"
		},
		{
		  "label": "No",
		  "value": "No"
		}
	  ],
	  "sQuestionnaireType": "User",
	  "bIsDependent": true,
	  "UserAnswer": null,
	  "DependQuestions": [
		{
		  "id": 6,
		  "sName": "Challengesfromsegment",
		  "sDisplayText": "Challenges from segment",
		  "sFieldType": "multiselect",
		  "listValues": [
			{
			  "label": "Marketing",
			  "value": "Marketing"
			},
			{
			  "label": "Sales",
			  "value": "Sales"
			},
			{
			  "label": "Funding",
			  "value": "Funding"
			},
			{
			  "label": "inventory",
			  "value": "inventory"
			},
			{
			  "label": "cash flow",
			  "value": "cash flow"
			},
			{
			  "label": "lead generation",
			  "value": "lead generation"
			},
			{
			  "label": "man power",
			  "value": "man power"
			},
			{
			  "label": "legal",
			  "value": "legal"
			},
			
		  ],
		  "sQuestionnaireType": "User",
		  "bIsDependent": false,
		  "UserAnswer": null,
		  "sDependentAnswer":"Yes"
		},
		{
		  "id": 7,
		  "sName": "UserFacedChalleges_goalsDetails",
		  "sDisplayText": "User faced challenges or goals in details",
		  "sFieldType": "textarea",
		  "listValues": "",
		  "sQuestionnaireType": "User",
		  "bIsDependent": false,
		  "UserAnswer": null,
		  "sDependentAnswer":"Yes"
		},
		
	  ],
	  
	},
	
  ];

  const arrayBusinessProfileQuestionaryData=[	
	{
	  "id": 3,
	  "sName": "EngagementCallStayEngaged",
	  "sDisplayText": "Engagement call - Stay Engaged",
	  "sFieldType": "select",
	  "listValues": [
		{
		  "label": "Yes",
		  "value": "Yes"
		},
		{
		  "label": "No",
		  "value": "No"
		}
	  ],
	  "sQuestionnaireType": "Business",
	  "bIsDependent": true,
	  "UserAnswer": null,
	  "DependQuestions": [
		{
		  "id": 4,
		  "sName": "NotEngagementReason",
		  "sDisplayText": "Not Engagement Reason",
		  "sFieldType": "textbox",
		  "listValues": "",
		  "sQuestionnaireType": "Business",
		  "bIsDependent": false,
		  "UserAnswer": null,
		  "sDependentAnswer":"No"
		},
		
	  ],
	  
	},
	{
	  "id": 5,
	  "sName": "DoesusersharedChallenges_Goal",
	  "sDisplayText": "Does user shared Challenges/Goal",
	  "sFieldType": "select",
	  "listValues": [
		{
		  "label": "Yes",
		  "value": "Yes"
		},
		{
		  "label": "No",
		  "value": "No"
		}
	  ],
	  "sQuestionnaireType": "Business",
	  "bIsDependent": true,
	  "UserAnswer": null,
	  "DependQuestions": [
		{
		  "id": 6,
		  "sName": "Challengesfromsegment",
		  "sDisplayText": "Challenges from segment",
		  "sFieldType": "multiselect",
		  "listValues": [
			{
			  "label": "Marketing",
			  "value": "Marketing"
			},
			{
			  "label": "Sales",
			  "value": "Sales"
			},
			{
			  "label": "Funding",
			  "value": "Funding"
			},
			{
			  "label": "inventory",
			  "value": "inventory"
			},
			{
			  "label": "cash flow",
			  "value": "cash flow"
			},
			{
			  "label": "lead generation",
			  "value": "lead generation"
			},
			{
			  "label": "man power",
			  "value": "man power"
			},
			{
			  "label": "legal",
			  "value": "legal"
			},
			
		  ],
		  "sQuestionnaireType": "Business",
		  "bIsDependent": false,
		  "UserAnswer": null,
		  "sDependentAnswer":"Yes"
		},
		{
		  "id": 7,
		  "sName": "UserFacedChalleges_goalsDetails",
		  "sDisplayText": "User faced challenges or goals in details",
		  "sFieldType": "textarea",
		  "listValues": "",
		  "sQuestionnaireType": "Business",
		  "bIsDependent": false,
		  "UserAnswer": null,
		  "sDependentAnswer":"Yes"
		},
		
	  ],
	  
	},
	
  ];

const USER_FIELDS = [
	{ key: "user_meta.nUserId", name: "User ID" },
	{ key: "user_meta.sEmailAddress", name: "Email Address" },
	{ key: "user_meta.sFirstName", name: "First Name" },
	{ key: "user_meta.sLastName", name: "Last Name" },
	{ key: "user_meta.sContactNumber", name: "Mobile #" },
	{ key: "user_meta.sAlternateContactNumber", name: "Alternate #" },
	{ key: "user_meta.dtDateofBirth", name: "DOB" },
	{ key: "user_meta.sGender", name: "Gender" },
	{ key: "user_meta.sPinCode", name: "Pincode" },
	{ key: "user_meta.sCity", name: "City" },
	{ key: "user_meta.sState", name: "State" },
	{ key: "user_meta.sCountry", name: "Country" },
	{ key: "user_meta.nEducation", name: "Education" },
	{ key: "user_meta.sEducation", name: "Other Education" },
	{ key: "additional_data.sSource", name: "Source" },
	{ key: "additional_data.sSpecificSource", name: "Source Specific" },
	//{ key: "user_meta.ClaimFreeListing", name: "Claim Free Listing"},
	//{ key: "user_meta.ProfileEnhancementRequest", name: "Profile Enhancement Request"},
	//{ key: "user_meta.DoNotSendSMS", name: "Do not send SMS" },
	
];

const BUSINESS_PROFILE_FIELDS = [
	{ key: "sBusinessName", name: "Business Name" },
	{ key: "sBusinessSector", name: "Business Sector" },
	{ key: "sBusinessType", name: "Business Type" },
	{ key: "sTypeOfOrganization", name: "Type of Organization" },
	{ key: "sBasicCompliances", name: "Basic Compliances" },
	{ key: "sBusinessNatures", name: "Nature of the Business" },
	

	{ key: "sPincode", name: "Business 	Pincode" },
	{ key: "sCountry", name: "Country" },
	{ key: "sState", name: "State" },
	{ key: "sCity", name: "City" },
	{ key: "nNoOfEmployees", name: "No. of Employees" },
	{ key: "sAnnualTurnOver", name: "Annual Turnover Rs." },
	{ key: "nYearOfEstablishment", name: "Year of Establishment" },
	
];
const phonePattern = /^\d{10}$/;
const pincodePattern = /^\d{6}$/;
const numberPattern = /^[0-9]*$/;

// const SELECT_EDUCATION_VALUES = [
// 	{ value: 1, label: "School Dropout" },
// 	{ value: 10, label: "10th Pass" },
// 	{ value: 12, label: "12th Pass" },
// 	{ value: 16, label: "Graduation" },
// 	{ value: 18, label: "Post Graduation" },
// 	{ value: -1, label: "Other" },
// ];
export default function UserProfileModal({ userProfileInitData, ...props }) {
	const [
		TYPE_OF_ORG_DROPDOWN_VALUES,
		setTypeOfOrgDropdownValues,
	] = useState();
	const [SELECT_EDUCATION_VALUES, setSelectEducationValues] = useState();
	const [
		SELECT_BUSINESS_TYPE_VALUES,
		setSelectBusinessTypeValues,
	] = useState();

	const [userMetaChangeLogData, setUserMetaChangeLogData] = useState();
	const { nResourceInstanceId, sEmailAddress } = userProfileInitData;
	const [userProfileData, setUserProfileData] = useState({});
	const [userOriginalProfileData, setOriginalUserProfileData] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [nUserId, setUserId] = useState();
	const [nResourceInstanceIdForUserProfile, setnResourceInstanceIdForUserProfile] = useState();
	const [nResourceInstanceIdForUserProfileLPM, setnResourceInstanceIdForUserProfileLPM] = useState();
	const validateAllBusinessProfiles = (business_profiles) => {
		let flag = true;
		for (let i = 0; i < business_profiles.length; i++) {
			if (validateBusinessProfile(business_profiles[i]) === false) {
				flag = false;
				break;
			}
		}
		return flag;
	};

	useEffect(() => {
		console.log("EmailID==",props)
	},[])

	const validateBusinessProfile = (business_profile) => {
		console.log(business_profile);
		if (
			business_profile["sAnnualTurnOver"] &&
			business_profile["sAnnualTurnOver"] !== "" &&
			numberPattern.test(business_profile["sAnnualTurnOver"]) === false
		) {
			toast(
				`Invalid Annual Turnover for ${business_profile["sBusinessName"]}`,
				{
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				}
			);
			return false;
		} else if (
			business_profile["nNoOfEmployees"] &&
			business_profile["nNoOfEmployees"] !== "" &&
			numberPattern.test(business_profile["nNoOfEmployees"]) === false
		) {
			toast(
				`Invalid Number of Employees for ${business_profile["sBusinessName"]}`,
				{
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				}
			);
			return false;
		} else if (
			business_profile["sPincode"] &&
			business_profile["sPincode"] !== "" &&
			pincodePattern.test(business_profile["sPincode"]) === false
		) {
			toast(`Invalid Pincode for ${business_profile["sBusinessName"]}`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return false;
		} else {
			return true;
		}
	};
	const saveCurrentBusinessProfile = (index) => {
		const { business_profiles } = userProfileData;
		if (validateBusinessProfile(business_profiles[index])) {

			let updated;
			if(business_profiles[index].nUserId)
			{
				updated = business_profiles[index];
			}
			else
			{
				updated = {...business_profiles[index],nUserId:nUserId};
			}
			
			const data = api
				.saveBusinessProfile({
					business_profiles: [updated],
				})
				.then(()=>{
					toast("Business profile saved successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					})
					getUpdatedUserProfiles();
				}
				)
				.catch((e) => {
					toast("Something went wrong. Contact webadmin support.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		}
	};

	const [
		showChangeEmailHistoryModal,
		setShowChangeEmailHistoryModal,
	] = useState(false);

	const toggleChangeEmailHistoryModal = () => {
		setShowChangeEmailHistoryModal(!showChangeEmailHistoryModal);
	};
	const [showUserMetaChangeLog, setShowUserMetaChangeLog] = useState(false);
	const toggleUserMetaChangeLog = () => {
		setShowUserMetaChangeLog(!showUserMetaChangeLog);
	};

	const [showAdditionalDataModal, setShowAdditionalDataModal] = useState(
		false
	);

	const toggleAdditionalDataModal = () => {
		setShowAdditionalDataModal(!showAdditionalDataModal);
	};

	const [showSupportedDataModal, setShowSupportedDataModal] = useState(false);

	const [genderSelectionOptions, setGenderSelectionOptions] = useState([
		{
			value: "male",
			label: "Male",
		},
		{
			value: "female",
			label: "Female",
		},
		{
			value: "NA",
			label: "NA",
		},
	]);

	const [genderSelection, setGenderSelection] = useState();
	const [educationSelection, setEducationSelection] = useState();
	const [otherEducationSelection, setOtherEducationSelection] = useState();
	const [dateOfBirth, setDateOfBirth] = useState();
	//const [donotSendSMS, setdonotSendSMS] = useState("");
	const [ClaimFreeListingOptions, setClaimFreeListingOptions] = useState([
		{
			value: "yes",
			label: "yes",
		},
		{
			value: "no",
			label: "no",
		}
	]);

	const [NatureoftheBusinessOptions, setNatureoftheBusinessOptions] = useState([
		{
			label: "Manufacturing",
			value: "Manufacturing"
		},
		{
			label: "Trading",
			value: "Trading"
		},
		{
			label: "Service",
			value: "Service"
		}
	]);

	const [BasicCompliancesOptions, setBasicCompliancesOptions] = useState([
		{
			label: "Business PAN",
			value: "Business PAN"
		},
		{
			label: "Shop Act",
			value: "Shop Act"
		},
		{
			label: "Incorporation Certificate",
			value: "Incorporation Certificate"
		}
	]);

	const [ClaimFreeListingSelection, setClaimFreeListingSelection] = useState();

	const [ProfileEnhancementRequestOptions, setProfileEnhancementRequestOptions] = useState([
		{
			value: "Opted",
			label: "Opted",
		},
		{
			value: "Not Opted",
			label: "Not Opted",
		},
		{
			value: "In Process",
			label: "In Process",
		},
		{
			value: "Published",
			label: "Published",
		},
		{
			value: "Not Published",
			label: "Not Published",
		},
	]);

	const [userServiceFeedbackData,setUserServiceFeedbackData,] = useState();

	const [ProfileEnhancementRequestSelection, setProfileEnhancementRequestSelection] = useState();

	const toggleSupportedDataModal = () => {
		setShowSupportedDataModal(!showSupportedDataModal);
	};
	const [isFacilitatorEngagementView, setisFacilitatorEngagementView] = useState(false);
	const toggleFacilitatorEngagementView = () => {
		setisFacilitatorEngagementView(!isFacilitatorEngagementView);
	};

	//Facilitator engagement states
	const [userOriginalProfileGenderData, setUserOriginalProfileGenderData] = useState({});
	const [UsersAllBusinessProfileQuestionaryData, setUsersAllBusinessProfileQuestionaryData] = useState([]);
	const [UserProfileQuestionaryData, setUserProfileQuestionaryData] = useState([]);
	const [BusinessProfileQuestionaryData, setBusinessProfileQuestionaryData] = useState([]);
	let UserProfileQuestionaryAnswers=[];
	let BusinessProfileQuestionaryAnswers=[];
	let BuisnessProfileMetaData = []
	const [UserBusinessOptions, setUserBusinessOptions] = useState([]);
	const [selectedUserBusinessOption, setselectedUserBusinessOption] = useState(null);
	const [selectedTabIndex,setselectedTabIndex]=useState({index:0});
	// end

	const [sCurrentServiceRequestStateForUserProfile, setsCurrentServiceRequestStateForUserProfile] = useState();

	const [userEmailAddressForFeedback, setUserEmailAddressForFeedback] = useState(null);
	const [showServiceFeedbackModal, onSetShowServiceFeedbackModal] = useState(false);
	const toggleServiceFeedbackModal = () => {
		onSetShowServiceFeedbackModal(!showServiceFeedbackModal);
	};
	const handleOnShowFeedback = (e, origin) => {
		toggleServiceFeedbackModal();
	};

	useEffect(() =>{
		if(props.isOpen)
		{
			if(props.showFacilitatorEngagementView)
			{
				setisFacilitatorEngagementView(props.showFacilitatorEngagementView);
			}
			else
			{
				setisFacilitatorEngagementView(false);
			}	

			/*if(props.nResourceInstanceIdForUserProfile&&props.refExternalServicePartnerEmailIDForFeedback&&sCurrentServiceRequestStateForUserProfile&&sCurrentServiceRequestStateForUserProfile=="Delivered")
			{
                let filterParameters={}
                filterParameters.search_value=props.nResourceInstanceIdForUserProfile;
                filterParameters.EmailAddress = props.refExternalServicePartnerEmailIDForFeedback;

                //setLoading(true);	
                const { tempServices } = api.getCustomerFeedbackList(filterParameters)
                .then(({ data }) => {
                    //setLoading(false);
                    if(data)
                    {
                      setUserServiceFeedbackData(data);                     
                    }
                    else
                    {
                        toast("no data found.", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                  }).catch((error) =>
                    {
                        //setLoading(false);
                        if(error.response.data.detail)
                        {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else if(error.response.data.message)
                        {
                            toast(String(error.response.data.message), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else
                        {
                            toast("Internal server error", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }            
                    });

			}*/
		}
		else
		{
			setisFacilitatorEngagementView(false);
		}
			
	},[props.isOpen]);

	useEffect(() => {
		setnResourceInstanceIdForUserProfile(props.nResourceInstanceIdForUserProfile);
	}, [props.nResourceInstanceIdForUserProfile]);

	useEffect(() => {
		setnResourceInstanceIdForUserProfileLPM(props.nResourceInstanceIdForUserProfileLPM);
	}, [props.nResourceInstanceIdForUserProfileLPM]);

	useEffect(() => {
		setsCurrentServiceRequestStateForUserProfile(props.sCurrentServiceRequestStateForUserProfile);
	}, [props.sCurrentServiceRequestStateForUserProfile]);


	useEffect(() => {
		if (props.nUserId) {
			setUserProfileData({});
			setOriginalUserProfileData({});
			setGenderSelection("");
			setEducationSelection();
			setOtherEducationSelection();
			setDateOfBirth();
			setUserEmailAddressForFeedback();
			
			setLoading(true);
			let temp = props.nUserId;
			api.getUserProfileData({
				nUserId: temp,
				sEmailAddress: sEmailAddress,
			}).then(({ data }) => {
				const { customer_profile_data } = data;
				setSelectEducationValues(customer_profile_data.Education);
				setSelectBusinessTypeValues(
					customer_profile_data.BusinessTypes
				);
				setGenderSelectionOptions(customer_profile_data.Gender);
				setTypeOfOrgDropdownValues(
					customer_profile_data.TypeOfOrganizations
				);
				setUserProfileData(customer_profile_data);
				setOriginalUserProfileData(customer_profile_data);

				if(customer_profile_data.BusinessNatures)
				{
					setNatureoftheBusinessOptions(
						customer_profile_data.BusinessNatures
					);
				}

				if(customer_profile_data.BasicCompliances)
				{
					setBasicCompliancesOptions(
						customer_profile_data.BasicCompliances
					);
				}

				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.sGender
				) {
					let gender = customer_profile_data.Gender.filter(
						(e) =>
							e.value === customer_profile_data.user_meta.sGender
					);
					setGenderSelection(gender[0]);
				}
				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.nEducation
				) {
					let education = customer_profile_data.Education.filter(
						(e) =>
							String(e.value) ===
							String(customer_profile_data.user_meta.nEducation)
					);

					setEducationSelection(education[0]);

					if (education[0].value === -1) {
						setEnableOtherEducation(true);
					}
				}
				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.sEducation
				) {
					setOtherEducationSelection(
						customer_profile_data.user_meta.sEducation
					);
				}
				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.dtDateofBirth
				) {
					setDateOfBirth(
						customer_profile_data.user_meta.dtDateofBirth
					);
				}

				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.sEmailAddress
				) {
					setUserEmailAddressForFeedback(
						customer_profile_data.user_meta.sEmailAddress
					);
				}

				/*if (customer_profile_data.user_meta &&customer_profile_data.user_meta.DoNotSendSMS) 
				{
					setdonotSendSMS(customer_profile_data.user_meta.DoNotSendSMS);
				}*/

				if (customer_profile_data.user_meta &&customer_profile_data.user_meta.ClaimFreeListing) 
				{
					let listing = ClaimFreeListingOptions.filter((e) =>
							e.value === customer_profile_data.user_meta.ClaimFreeListing
					);
					setClaimFreeListingSelection(listing[0]);
				}
				else{
					setClaimFreeListingSelection(null);
				}

				if (customer_profile_data.user_meta &&customer_profile_data.user_meta.ProfileEnhancementRequest) 
				{
					let listing = ProfileEnhancementRequestOptions.filter((e) =>
							e.value === customer_profile_data.user_meta.ProfileEnhancementRequest
					);
					setProfileEnhancementRequestSelection(listing[0]);
				}
				else{
					setProfileEnhancementRequestSelection(null);
				}

				const { business_profiles = [] } = customer_profile_data;
				let business_profiles_options=[];
				business_profiles.map((e) =>
				{
					if(e["sBusinessId"])
					{
						let name=e["sBusinessName"] && e["sBusinessName"].length? e["sBusinessName"]: "-NA-";
						let sector=e["sBusinessSector"] && e["sBusinessSector"].length? e["sBusinessSector"]: "-NA-";
						let BusinessName=name+"("+sector+")";
						business_profiles_options.push({
							value:e["sBusinessId"],
							label:BusinessName
						});
						if(props.sBusinessNameForUserProfile&&props.sSectorNameForUserProfile)
						{
							let selectedBusiness=props.sBusinessNameForUserProfile+"("+props.sSectorNameForUserProfile+")";
							if(selectedBusiness===BusinessName)
							{
								setselectedUserBusinessOption(e["sBusinessId"]);
							}
						}
					}
				}); 

				setUserBusinessOptions(business_profiles_options);
				setLoading(false);
			});
		} else {
			const user_meta = pick(userProfileInitData, [
				"sFirstName",
				"sLastName",
				"sContactNumber",
				"sEmailAddress",
			]);
			setUserProfileData({ user_meta });
		}

		if (nUserId) {
			api.getUserMetaChangeLog({
				search_value: String(props.nUserId),
			}).then((d) => {
				setUserMetaChangeLogData(d.data.data);
			});
		}

		if (props.nUserId) 
		{
			api.getUserQuestionnaire({user_id: props.nUserId}).then((d) => {
				let record=null;
				d.data.user.map((e) =>{
					if(e.sName==='Gender')
					{
						setUserOriginalProfileGenderData(e.UserAnswer);
					}
				}
				);				
				setUserProfileQuestionaryData(d.data.user);
			});

			api.getUserBusinessQuestionnaire({user_id: props.nUserId}).then((d) => {
				setUsersAllBusinessProfileQuestionaryData(d.data);
			});
		}
		setUserId(props.nUserId);
	}, [nUserId, props.nUserId, sEmailAddress,props.sBusinessNameForUserProfile,props.sSectorNameForUserProfile]);

	const getUpdatedUserProfiles=()=>{

		setLoading(true);
			let temp = props.nUserId;
			api.getUserProfileData({
				nUserId: temp,
				sEmailAddress: sEmailAddress,
			}).then(({ data }) => {
				const { customer_profile_data } = data;
				setSelectEducationValues(customer_profile_data.Education);
				setSelectBusinessTypeValues(
					customer_profile_data.BusinessTypes
				);
				setGenderSelectionOptions(customer_profile_data.Gender);
				setTypeOfOrgDropdownValues(
					customer_profile_data.TypeOfOrganizations
				);
				setUserProfileData(customer_profile_data);
				setOriginalUserProfileData(customer_profile_data);

				if(customer_profile_data.BusinessNatures)
				{
					setNatureoftheBusinessOptions(
						customer_profile_data.BusinessNatures
					);
				}

				if(customer_profile_data.BasicCompliances)
				{
					setBasicCompliancesOptions(
						customer_profile_data.BasicCompliances
					);
				}

				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.sGender
				) {
					let gender = customer_profile_data.Gender.filter(
						(e) =>
							e.value === customer_profile_data.user_meta.sGender
					);
					setGenderSelection(gender[0]);
				}
				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.nEducation
				) {
					let education = customer_profile_data.Education.filter(
						(e) =>
							String(e.value) ===
							String(customer_profile_data.user_meta.nEducation)
					);

					setEducationSelection(education[0]);

					if (education[0].value === -1) {
						setEnableOtherEducation(true);
					}
				}
				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.sEducation
				) {
					setOtherEducationSelection(
						customer_profile_data.user_meta.sEducation
					);
				}
				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.dtDateofBirth
				) {
					setDateOfBirth(
						customer_profile_data.user_meta.dtDateofBirth
					);
				}

				if (
					customer_profile_data.user_meta &&
					customer_profile_data.user_meta.sEmailAddress
				) {
					setUserEmailAddressForFeedback(
						customer_profile_data.user_meta.sEmailAddress
					);
				}

				/*if (customer_profile_data.user_meta &&customer_profile_data.user_meta.DoNotSendSMS) 
				{
					setdonotSendSMS(customer_profile_data.user_meta.DoNotSendSMS);
				}*/

				if (customer_profile_data.user_meta &&customer_profile_data.user_meta.ClaimFreeListing) 
				{
					let listing = ClaimFreeListingOptions.filter((e) =>
							e.value === customer_profile_data.user_meta.ClaimFreeListing
					);
					setClaimFreeListingSelection(listing[0]);
				}
				else{
					setClaimFreeListingSelection(null);
				}

				if (customer_profile_data.user_meta &&customer_profile_data.user_meta.ProfileEnhancementRequest) 
				{
					let listing = ProfileEnhancementRequestOptions.filter((e) =>
							e.value === customer_profile_data.user_meta.ProfileEnhancementRequest
					);
					setProfileEnhancementRequestSelection(listing[0]);
				}
				else{
					setProfileEnhancementRequestSelection(null);
				}

				const { business_profiles = [] } = customer_profile_data;
				let business_profiles_options=[];
				business_profiles.map((e) =>
				{
					if(e["sBusinessId"])
					{
						let name=e["sBusinessName"] && e["sBusinessName"].length? e["sBusinessName"]: "-NA-";
						let sector=e["sBusinessSector"] && e["sBusinessSector"].length? e["sBusinessSector"]: "-NA-";
						let BusinessName=name+"("+sector+")";
						business_profiles_options.push({
							value:e["sBusinessId"],
							label:BusinessName
						});
						if(props.sBusinessNameForUserProfile&&props.sSectorNameForUserProfile)
						{
							let selectedBusiness=props.sBusinessNameForUserProfile+"("+props.sSectorNameForUserProfile+")";
							if(selectedBusiness===BusinessName)
							{
								setselectedUserBusinessOption(e["sBusinessId"]);
							}
						}
					}
				}); 

				setUserBusinessOptions(business_profiles_options);
				setLoading(false);
			});

			if (nUserId) {
				api.getUserMetaChangeLog({
					search_value: String(props.nUserId),
				}).then((d) => {
					setUserMetaChangeLogData(d.data.data);
				});
			}
	
			if (props.nUserId) 
			{
				api.getUserQuestionnaire({user_id: props.nUserId}).then((d) => {
					d.data.user.map((e) =>{
						if(e.sName==='Gender')
						{
							setUserOriginalProfileGenderData(e.UserAnswer);
						}
					}
					);
					setUserProfileQuestionaryData(d.data.user);
				});
	
				api.getUserBusinessQuestionnaire({user_id: props.nUserId}).then((d) => {
					setUsersAllBusinessProfileQuestionaryData(d.data);
				});
			}
	}

	const getSelectedValue = (key) => {
		let selectedRole = {};
		const nEducation = get(userProfileData, key);

		if (nEducation) {
			selectedRole = SELECT_EDUCATION_VALUES.filter(
				(option) => String(option.value) === String(nEducation)
			);
			return selectedRole;
		}
	};
	const [enableOtherEducation, setEnableOtherEducation] = useState(false);
	const toggleEnableOtherEducation = (value) => {
		if (value === -1) {
			setEnableOtherEducation(true);
		} else {
			handleInputChange("user_meta.sEducation", "");
			setEnableOtherEducation(false);
			setOtherEducationSelection("");
		}
	};
	/**
	 * render input fields callback
	 */

	const renderUserFields = () => {
		return USER_FIELDS.map((field, index) => {
			const { key, name } = field;
			if (key === "user_meta.dtDateofBirth") {
				return (
					<>
						<span>DOB</span>
						<br></br>
						<ReactDatePicker
							selected={
								dateOfBirth ? new Date(dateOfBirth) : null
							}
							dateFormat="dd/MM/yyyy"
							onChange={(date) => {
								setDateOfBirth(date);
								handleInputChange(key, date);
							}}
						/>
						<br></br>
					</>
				);
			}
			if (key === "user_meta.sEducation") {
				return (
					<div
						className={`${
							// otherEducationSelection &&
							// otherEducationSelection.length > 0
							enableOtherEducation ? "" : "cursor-not-allowed"
						}`}
					>
						<ControlledInput
							key={index}
							name={key}
							label={name}
							value={
								enableOtherEducation
									? otherEducationSelection
									: ""
							}
							onChange={({ target }) => {
								setOtherEducationSelection(target.value);
								handleInputChange(key, target.value);
							}}
							className={`${
								// otherEducationSelection &&
								// otherEducationSelection.length > 0
								enableOtherEducation
									? ""
									: "disabled pointer-events-none"
							}`}
						></ControlledInput>
					</div>
				);
			} else if (key == "user_meta.nEducation") {
				return (
					<div style={{marginBottom:"1rem"}}>
						<label>{name}</label>
						<Select
							key={index}
							name={key}
							label={name}
							value={educationSelection}
							options={SELECT_EDUCATION_VALUES}
							onChange={(value) => {
								toggleEnableOtherEducation(value.value);
								setEducationSelection(value);
								handleInputChange(key, value.value);
							}}
						/>
					</div>
				);
			} else if (key === "user_meta.sGender") {
				return (
					<div style={{marginBottom:"1rem"}}>
						<label>{name}</label>
						<Select
							label={name}
							placeholder="Select gender"
							options={genderSelectionOptions}
							onChange={(value) => {
								setGenderSelection(value);
								handleInputChange(key, value.value);
							}}
							value={genderSelection}
							isDisabled={userOriginalProfileData.user_meta&&userOriginalProfileData.user_meta.sGender?true:false}
							// className={`${props.filterError ? "border-error" : ""}`}
						/>
					</div>
					
				);
			}
			else if (key === "user_meta.ClaimFreeListing") {
				return (
					nResourceInstanceIdForUserProfile?(
					<div style={{marginBottom:"1rem"}}>
						<label>{name}</label>
						<Select
							label={name}
							placeholder="Select claim free listing"
							options={ClaimFreeListingOptions}
							onChange={(value) => {
								setClaimFreeListingSelection(value);
								handleInputChange(key, value.value);
							}}
							value={ClaimFreeListingSelection}
						/>
					</div>):("")
					
				);
			}
			else if (key === "user_meta.ProfileEnhancementRequest") {
				return (
					nResourceInstanceIdForUserProfile?(
					<div style={{marginBottom:"1rem"}}>
						<label>{name}</label>
						<Select
							label={name}
							placeholder="Select profile enhancement"
							options={ProfileEnhancementRequestOptions}
							onChange={(value) => {
								setProfileEnhancementRequestSelection(value);
								handleInputChange(key, value.value);
							}}
							value={ProfileEnhancementRequestSelection}
						/>
					</div>):""
					
				);
			}
			/*else if (key === "user_meta.DoNotSendSMS") {
				return (
					<Checkbox
						style={{marginTop:"10px"}}
						label="Do not send SMS"
						name="DoNotSendSMS"
						id="DoNotSendSMS"
						value={
							donotSendSMS? donotSendSMS: false
						}
						checked={
							donotSendSMS? donotSendSMS: false
						}
						onChange={({ target: { name, checked } }) =>{
							setdonotSendSMS(checked)
							handleInputChange(key, checked)
						}}
					></Checkbox>
				);
			} */else {
				return (
					<div
						className={`${
							field.key === "additional_data.sSpecificSource" ||
							field.key === "additional_data.sSource" ||
							field.key === "user_meta.nUserId" ||
							field.key === "user_meta.sEmailAddress" ||
							field.key === "user_meta.sCity" ||
							field.key === "user_meta.sState" ||
							field.key === "user_meta.sCountry"
								? "cursor-not-allowed"
								: ""
						}`}
					>
						<ControlledInput
							key={index}
							name={key}
							label={name}
							value={get(userProfileData, key) || ""}
							onChange={({ target }) =>
								handleInputChange(key, target.value)
							}
							className={`${
								field.key ===
									"additional_data.sSpecificSource" ||
								field.key === "additional_data.sSource" ||
								field.key === "user_meta.nUserId" ||
								field.key === "user_meta.sEmailAddress" ||
								field.key === "user_meta.sCity" ||
								field.key === "user_meta.sState" ||
								field.key === "user_meta.sCountry"
									? "disabled pointer-events-none"
									: ""
							}`}
						></ControlledInput>
					</div>
				);
			}
		});
	};

	const renderBusinessProfiles = () => {
		const { business_profiles = [] } = userProfileData;
		let tabHeaders = business_profiles.map((e) => (
			<>
				<Tab>
					<span>
						{e["sBusinessName"] && e["sBusinessName"].length
							? e["sBusinessName"]
							: "-NA-"}
					</span>{" "}
					<span>
						(
						{e["sBusinessSector"] && e["sBusinessSector"].length
							? e["sBusinessSector"]
							: "-NA-"}
						)
					</span>
				</Tab>
			</>
		));

		let tabs = business_profiles.map((profile, index) => (
			<TabPanel>
				<div>
					<div className="row" style={{ float: "right" }}>
						<div className="mt-2 col-md-12">
							<>
								{profile["sBusinessName"] === null &&
								profile["sBusinessSector"] === null ? (
									<></>
								) : (
									<>
										<Button
											onClick={() =>
												saveCurrentBusinessProfile(
													index
												)
											}
										>
											Save Profile
										</Button>
										<br></br>
									</>
								)}
							</>
						</div>
					</div>
					<div className="row ml-2">
						<div className="mt-2 col-md-12">
							<BusinessProfile
								key={index}
								businessProfile={profile}
								businessIndex={index}
								TYPE_OF_ORG_DROPDOWN_VALUES={
									TYPE_OF_ORG_DROPDOWN_VALUES
								}
								SELECT_BUSINESS_TYPE_VALUES={
									SELECT_BUSINESS_TYPE_VALUES
								}
								onInputChange={handleBusinessProfileInputChange}
								NatureoftheBusinessOptions={NatureoftheBusinessOptions}
								BasicCompliancesOptions={BasicCompliancesOptions}
							/>
							{/* profile.length !== 0 || */}
							{false ? (
								"No resource data available"
							) : (
								// style={{ width: "1243px" }} ServicesData
								<div>
									<div>
										<span>
											<br></br>
											<b className="resource-data-style heading">
												SERVICE REQUESTS - LPM
											</b>
											<br></br>
										</span>
										{/* profile["ServiceRequests"].length === 0 */}
										{!("ServiceRequests" in profile) ? (
											<span>No data to display</span>
										) : (
											<ServiceRequestsData
												key={index}
												serviceRequestData={profile}
											></ServiceRequestsData>
										)}
									</div>
									<br></br>
									<div>
										<span>
											<br></br>
											<b className="resource-data-style heading">
												SERVICE REQUESTS - SPM
											</b>
											<br></br>
										</span>
										{/* profile["ServiceRequests"].length === 0 */}
										{!("Services" in profile) ? (
											<span>No data to display</span>
										) : (
											<ServicesData
												key={index}
												serviceRequestData={profile}
											></ServicesData>
										)}
									</div>
									<br></br>
									<div>
										<div>
											<div>
												<span>
													<br></br>
													<b className="resource-data-style heading">
														PERSONALIZED RESOURCES
													</b>
													<br></br>
												</span>

												<ResourceData
													key={index}
													resourceData={profile}
												></ResourceData>
											</div>
											<br></br>
											<div>
												<span>
													<br></br>
													<b className="resource-data-style heading">
														KNOWLEDGE RESOURCES
													</b>
													<br></br>
												</span>

												<ChecklistData
													key={index}
													checklistData={profile}
												></ChecklistData>
											</div>
										</div>
									</div>
								</div>
							)}
							<hr></hr>
						</div>
					</div>
				</div>
			</TabPanel>
		));
		const { resources_data = [] } = userProfileData;

		return (
			<>
				<Tabs>
					<TabList>{tabHeaders}</TabList>
					{tabs}
				</Tabs>
			</>
		);
	};

	/**
	 * input change callbacks
	 */
	const handleInputChange = async (name, value) => {
		const splitName = split(name, ".");
		const parent = splitName[0];
		const child = splitName[1];

		if (child === "sPinCode" && String(value).length === 6) {
			const { data } = await api.findDetailsWithPincode({
				pincode: value,
			});
			let updatedChild;
			if (data.PostOffice && data.PostOffice.length > 0) {
				updatedChild = {
					...userProfileData[parent],
					[child]: value,
					sCity: data.PostOffice[0]["Circle"],
					sState: data.PostOffice[0]["State"],
					sCountry: data.PostOffice[0]["Country"],
				};
			} else {
				updatedChild = {
					...userProfileData[parent],
					[child]: value,
					sCity: "",
					sState: "",
					sCountry: "",
				};
			}

			const updated = { ...userProfileData, [parent]: updatedChild };
			setUserProfileData(updated);
		} else {
			const updatedChild = { ...userProfileData[parent], [child]: value };
			const updated = { ...userProfileData, [parent]: updatedChild };
			setUserProfileData(updated);
		}
	};
	const handleBusinessProfileInputChange = async (name, value, index) => {
		if (name === "sPincode" && String(value).length === 6) {
			const { data } = await api.findDetailsWithPincode({
				pincode: value,
			});
			const { business_profiles } = userProfileData;
			let updated;
			if (data.PostOffice && data.PostOffice.length > 0) {
				updated = {
					...business_profiles[index],
					[name]: value,
					sCity: data.PostOffice[0]["Circle"],
					sState: data.PostOffice[0]["State"],
					sCountry: data.PostOffice[0]["Country"],
				};
			} else {
				updated = {
					...business_profiles[index],
					[name]: value,
					sCity: "",
					sState: "",
					sCountry: "",
				};
			}

			business_profiles.splice(index, 1, updated);
			setUserProfileData({ ...userProfileData, business_profiles });
		}
		else if(name==="sBasicCompliances")
		{
			var tempselectedvalues=[];
			let tempSR = value.map((o) => 
			{
				tempselectedvalues = tempselectedvalues.concat(o.value);
				return value;
			});
			const { business_profiles } = userProfileData;
			const updated = { ...business_profiles[index], [name]: tempselectedvalues };

			business_profiles.splice(index, 1, updated);
			setUserProfileData({ ...userProfileData, business_profiles });
		}
		else {
			const { business_profiles } = userProfileData;
			const updated = { ...business_profiles[index], [name]: value };

			business_profiles.splice(index, 1, updated);
			setUserProfileData({ ...userProfileData, business_profiles });
		}
	};

	const onSaveUserProfile = async () => {
		try {
			setLoading(true);
			const updatedChild = {
				...userProfileData["user_meta"],
				override: true,
				is_create: false,
			};
			const updated = { ...userProfileData, user_meta: updatedChild ,nResourceInstanceId: nResourceInstanceIdForUserProfile||nResourceInstanceIdForUserProfileLPM};
			setUserProfileData(updated);
			let { user_meta } = updated;
			let { business_profiles } = updated;
			if (validateAllBusinessProfiles(business_profiles) === false) {
				return;
			} else if (
				user_meta["sContactNumber"] !== "" &&
				phonePattern.test(user_meta["sContactNumber"]) === false
			) {
				toast("Invalid contact number.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} else if (
				user_meta["sAlternateContactNumber"] !== "" &&
				phonePattern.test(user_meta["sAlternateContactNumber"]) ===
					false
			) {
				toast("Invalid alternate contact number.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} else if (
				user_meta["sPinCode"] !== "" &&
				pincodePattern.test(user_meta["sPinCode"]) === false
			) {
				toast("Invalid pincode.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} else {
				api.saveUserProfileData(updated).then((res) => {
					if(res.data.message)
					{
						toast(res.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else
					{
						toast("User profile saved successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}			
					getUpdatedUserProfiles();
					api.getUserQuestionnaire({user_id: nUserId}).then((d) => {
						setUserProfileQuestionaryData(d.data.user);
					});
				});			
				
			}
		} catch (error) {
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} finally {
			setLoading(false);
		}
	};

	const onCreateUserProfile = async () => {
		try {
			setLoading(true);
			const updatedChild = {
				...userProfileData["user_meta"],
				override: false,
				is_create: true,
			};
			const updated = { ...userProfileData, user_meta: updatedChild ,nResourceInstanceId: nResourceInstanceIdForUserProfile||nResourceInstanceIdForUserProfileLPM};
			setUserProfileData(updated);
			const { data } = await api.saveUserProfileData(updated);
			const serviceData1 = await api
				.updateUserId({
					nResourceInstanceId,
					sEmailAddress,
					nUserId: data["nUserId"],
				})
				.then(({ data }) => {
					props.updateSelectedServiceRequest(data);
					setUserId(data["nUserId"]);
					toast("User profile saved successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				});
		} catch (error) {
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	const downloadResourcesData = () => {
		try {
			setLoading(true);
			api.downloadResourceData({ sEmailAddress }).then(({ data }) => {
				window.open(data["generated_file"], "_self");
				setLoading(false);
			});
		} catch (error) {
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	const onSendClaimFreeListingSMS = async () => {
		try 
		{
			setLoading(true);
			if(nResourceInstanceIdForUserProfile) 
			{
				var payload={nResourceInstanceId:nResourceInstanceIdForUserProfile}
				const { data: _ignore_ } = await api.sendClaimFreeListingSMSToUser(payload);
				toast("SMS sent to user successfully.", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
		} 
		catch (error) 
		{
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} 
		finally 
		{		
			setLoading(false);
		}
	};

	const onUpdatedePrenuerDetails = async () => {
		try 
		{
			setLoading(true);
			if(userEmailAddressForFeedback) 
			{
				let ClaimFreeListing="";
				let ProfileEnhancementRequest="";

				if(ClaimFreeListingSelection&&ClaimFreeListingSelection.value)
				{
					ClaimFreeListing=ClaimFreeListingSelection.value;
				}

				if(ProfileEnhancementRequestSelection&&ProfileEnhancementRequestSelection.value)
				{
					ProfileEnhancementRequest=ProfileEnhancementRequestSelection.value;
				}

				var payload={
					EmailAddress:userEmailAddressForFeedback,
					ClaimFreeListing:ClaimFreeListing,
					ProfileEnhancementRequest:ProfileEnhancementRequest
				}

				const { data: _ignore_ } = await api.updatedePrenuerDetails(payload);
				toast("dePrenuer details updated successfully.", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
		} 
		catch (error) 
		{
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} 
		finally 
		{		
			setLoading(false);
		}
	};

	//Facilitator Engagement callbacks

	const onTabChanged = (index)=>
    {
        setselectedTabIndex(index);
    }

	useEffect(()=>{
		if(selectedUserBusinessOption&&UsersAllBusinessProfileQuestionaryData&&UsersAllBusinessProfileQuestionaryData[selectedUserBusinessOption])
		{
			setBusinessProfileQuestionaryData(UsersAllBusinessProfileQuestionaryData[selectedUserBusinessOption]);
		}
		else
		{
			setBusinessProfileQuestionaryData([]);
		}
		
	},[selectedUserBusinessOption,UsersAllBusinessProfileQuestionaryData])

	const onUserBusinessChange = async (e) => {
		setselectedUserBusinessOption(e.value);
	};

	const onUserEngagementDataChange = async (e,field) => {

		if(field.sFieldType=="select")	
		{
			if(field.sQuestionnaireType==="user")
			{
				const updated =setUpdatedValue(UserProfileQuestionaryData,field,e.value);
				setUserProfileQuestionaryData(updated);
			}
			else
			{
				const updated =setUpdatedValue(BusinessProfileQuestionaryData,field,e.value);
				setBusinessProfileQuestionaryData(updated);
			}
			
		}
		else if(field.sFieldType=="textbox")
		{
			if(field.sQuestionnaireType==="user")
			{
				const updated =setUpdatedValue(UserProfileQuestionaryData,field,e.target.value);
				setUserProfileQuestionaryData(updated);
			}
			else
			{
				const updated =setUpdatedValue(BusinessProfileQuestionaryData,field,e.target.value);
				setBusinessProfileQuestionaryData(updated);
			}
		}
		else if(field.sFieldType=="textarea")
		{
			if(field.sQuestionnaireType==="user")
			{
				const updated =setUpdatedValue(UserProfileQuestionaryData,field,e.target.value);
				setUserProfileQuestionaryData(updated);
			}
			else
			{
				const updated =setUpdatedValue(BusinessProfileQuestionaryData,field,e.target.value);
				setBusinessProfileQuestionaryData(updated);
			}
		}
		else if(field.sFieldType=="multiselect")
		{
			var tempselectedvalues=[];
			let tempSR = e.map((o) => 
			{
				tempselectedvalues = tempselectedvalues.concat(o.value);
				return e;
			});

			if(field.sQuestionnaireType==="user")
			{
				const updated =setUpdatedValue(UserProfileQuestionaryData,field,tempselectedvalues);
				setUserProfileQuestionaryData(updated);
			}
			else
			{
				const updated =setUpdatedValue(BusinessProfileQuestionaryData,field,tempselectedvalues);
				setBusinessProfileQuestionaryData(updated);
			}
		}
		else if(field.sFieldType=="checkbox")
		{
			if(field.sQuestionnaireType==="user")
			{
				const updated =setUpdatedValue(UserProfileQuestionaryData,field,e.target.checked);
				setUserProfileQuestionaryData(updated);
			}
			else
			{
				const updated =setUpdatedValue(BusinessProfileQuestionaryData,field,e.target.checked);
				setBusinessProfileQuestionaryData(updated);
			}
		}
	};

	const setUpdatedValue = (QestionArray,AnsweredQuestion,userAns) => {

		const Fields = QestionArray.map((field) => {
			if(field.id===AnsweredQuestion.id)
			{
				field.UserAnswer=userAns;
				return field;
			}
			else
			{
				if(field.bIsDependent)
				{
					field.DependQuestions=setUpdatedValue(field.DependQuestions,AnsweredQuestion,userAns)
				}	
				return field;		
			}
		});

		return Fields;
	}

	const renderFacilitatorEngagement = () => {	

		let UserProfileFields ="";
		let BusinessProfileFields ="";

		if(UserProfileQuestionaryData)
		{
			UserProfileFields = UserProfileQuestionaryData.map((field) => {
				if(field.bIsDependent)
				{
					var dependentFields=getDependentQuestions(field,field.DependQuestions);
					return (
						<>
							{getField(field)}
							{dependentFields}
						</>
					)
				}
				else
				{
					return getField(field);
				}
			});
		}

		if(BusinessProfileQuestionaryData)
		{
			BusinessProfileFields = BusinessProfileQuestionaryData.map((field) => {
				if(field.bIsDependent)
				{
					var dependentFields=getDependentQuestions(field,field.DependQuestions);
					return (
						<>
							{getField(field)}
							{dependentFields}
						</>
					)
				}
				else
				{
					return getField(field);
				}
			});
		}

		

		return (
			<>
				<Tabs>
					<TabList>
						<Tab tabIndex={"1000"}>
							<span>
								User Profile
							</span>
						</Tab>
						<Tab tabIndex={"1001"}>
							<span>
								Business Profile
							</span>
						</Tab>
						<Tab tabIndex={"1002"}>
							<span>
							dePreneur Listing
							</span>
						</Tab>
					</TabList>
					<TabPanel>
					<div>
						{
							UserProfileQuestionaryData&&UserProfileQuestionaryData.length>0?
							(
								<>
									<div className="row">
										{UserProfileFields}
									</div>
									<div className="row">
										<div className="col-md-12">
											<div style={{float:"right"}}>
												<Button onClick={onSaveUserQuestionary}>
													Save
												</Button>
											</div>
										</div>
									</div>
								</>
							):
							(
								<div className="row">
									<span>No data to display</span>
								</div>
							)
						}
						
					</div>
					</TabPanel>
					<TabPanel>
					<div>
						<div className="row">
						<div className="col-md-6">
							<label>Select Business Profile:</label>
						</div>
						<div className="col-md-6">
							<div style={{marginBottom: "1rem"}}>
								<Select
									name={"sBusinessId"}
									value={getSelectedItem(UserBusinessOptions,selectedUserBusinessOption)}
									options={UserBusinessOptions}
									onChange={(e) =>onUserBusinessChange(e)}
								/>
							</div>
						</div>
						</div>
						{
							BusinessProfileQuestionaryData&&BusinessProfileQuestionaryData.length>0?
							(
								<>
									<div className="row">
										{BusinessProfileFields}
									</div>
									<div className="row">
										<div className="col-md-12">
											<div style={{float:"right"}}>
												<Button onClick={onSaveBusinessQuestionary}>
													Save
												</Button>
											</div>
										</div>
									</div>
								</>
							):
							(
								<div className="row">
									<span>No data to display</span>
								</div>
							)
						}
						
					</div>
					</TabPanel>
					<TabPanel>
					<div>
						<div className="row">
							<div className="col-md-6">
								<label>Claim Free Listing:</label>
							</div>
							<div className="col-md-6">
								<div style={{marginBottom: "1rem"}}>
									<Select
										placeholder="Select claim free listing"
										options={ClaimFreeListingOptions}
										onChange={(value) => {
											setClaimFreeListingSelection(value);
										}}
										value={ClaimFreeListingSelection}
									/>
								</div>
							</div>
							<div className="col-md-6">
								<label>Profile Enhancement Request:</label>
							</div>
							<div className="col-md-6">
								<div style={{marginBottom: "1rem"}}>
									<Select
										placeholder="Select profile enhancement"
										options={ProfileEnhancementRequestOptions}
										onChange={(value) => {
											setProfileEnhancementRequestSelection(value);
										}}
										value={ProfileEnhancementRequestSelection}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<div style={{float:"right"}}>
									<Button onClick={onSendClaimFreeListingSMS} style={{marginRight:"10px"}}>
										Send Claim Free Listing SMS
									</Button>
									<Button onClick={onUpdatedePrenuerDetails}>
										Save
									</Button>
								</div>
							</div>
						</div>
						
					</div>
					</TabPanel>
				</Tabs>
			</>
		);
	};

	const getDependentQuestions = (DependQuestion,DependentQuestions) => {

		const Fields = DependentQuestions.map((field,index) => {
			if(field.bIsDependent)
			{
				var dependentFields=getDependentQuestions(field,field.DependQuestions);
				return (
					<>
						{getField(field)}
						{dependentFields}
					</>
				)
			}
			else
			{
				if(DependQuestion.UserAnswer===field.sDependentAnswer)
				{
					return getField(field);
				}
				else
				{
					return "";
				}				
			}
		});

		return Fields;
	}

	const getField=(field)=>{
		if (field.sFieldType === "select")
		{
			if(field.sName==='Gender')
			{
				return (
					<>
						<div className="col-md-6">
							<label>{field.sDisplayText}:</label>
						</div>
						<div className="col-md-6">
							<div style={{marginBottom: "1rem"}}>
								<Select
									key={field.id}
									name={field.sName}
									value={getSelectedItem(field.listValues,field.UserAnswer)}
									options={field.listValues}
									onChange={(e) =>onUserEngagementDataChange(e,field)}
									isDisabled={userOriginalProfileGenderData?true:false}
								/>
							</div>
						</div>
					</>
				);
			}
			else
			{
				return (
					<>
						<div className="col-md-6">
							<label>{field.sDisplayText}:</label>
						</div>
						<div className="col-md-6">
							<div style={{marginBottom: "1rem"}}>
								<Select
									key={field.id}
									name={field.sName}
									value={getSelectedItem(field.listValues,field.UserAnswer)}
									options={field.listValues}
									onChange={(e) =>onUserEngagementDataChange(e,field)}
								/>
							</div>
						</div>
					</>
				);
			}
			
		}
		else if(field.sFieldType === "textbox")
		{
			return(
				<>
					<div className="col-md-6">
					<label>{field.sDisplayText}:{field.id===4?(<span className="required ml5">*</span>):("")}</label>
					</div>
					<div className="col-md-6">
						<ControlledInput
							key={field.id}
							name={field.sName}
							value={field.UserAnswer||""}
							onChange={(e) =>onUserEngagementDataChange(e,field)}
						/>
					</div>
				</>
			);
		}
		else if(field.sFieldType === "textarea")
		{
			return(
				<>
					<div className="col-md-6">
					<label>{field.sDisplayText}:{field.id===4?(<span className="required ml5">*</span>):("")}</label>
					</div>
					<div className="col-md-6">
						<div style={{marginBottom: "1rem"}}>
							<textarea
								className="w-100 form-control rounded"
								key={field.id}
								name={field.sName}
								value={field.UserAnswer||""}
								onChange={(e) =>onUserEngagementDataChange(e,field)}
								style={{minHeight:"20px"}}
							/>
						</div>
					</div>
				</>
			);
		}
		else if(field.sFieldType === "multiselect")
		{
			return (
				<>
					<div className="col-md-6">
						<label>{field.sDisplayText}:</label>
					</div>
					<div className="col-md-6">
						<div style={{marginBottom: "1rem"}}>
							<ReactMultiSelectCheckboxes
								key={field.id}
								name={field.sName}
								options={field.listValues}
								placeholderButtonLabel="Select.."
								value={getMultiSelectedItem(field.listValues,field.UserAnswer)}
								onChange={(e) =>onUserEngagementDataChange(e,field)}
								//setState={setSelectedOptions}
							/>
						</div>
					</div>
				</>
			);
		}
		else if(field.sFieldType === "checkbox")
		{
			return (
				<>
					<div className="col-md-6">
						<label>{field.sDisplayText}:</label>
					</div>
					<div className="col-md-6">
						<div style={{marginBottom: "1rem"}}>
								<Checkbox
									id={field.id}
									key={field.id}
									name={field.sName}
									checked={field.UserAnswer || false}
									onChange={(e) =>{
										e.stopPropagation();
										onUserEngagementDataChange(e,field)}}									
									onClick={(e) => {
										e.stopPropagation();
									}}
								/>
						</div>
					</div>
				</>
			);
		}
		else if(field.sFieldType === "Feedback Count")
		{
			return (
				<>
					<div className="col-md-6">
						<label>{field.sDisplayText}:</label>
					</div>
					<div className="col-md-6">
						<div style={{marginBottom: "1rem"}}>								
								<a 
									id={field.id} 
									href="javascript:void(0);" 
									onClick={(e) => toggleServiceFeedbackModal()} 
									target="_self"
								>
									{field.UserAnswer||0}
								</a>
						</div>
					</div>
				</>
			);
		}
	}

	const getSelectedItem = (Options,value) => {
		if (!Options) return null;
		const found = find(Options, {
			value: value,
		});
		if (found) {
			return found;
		}
		return null;
	};

	const getMultiSelectedItem = (Options,values) => {
		let temp =[];
		if(values)
		{
			let tempSR = Options.map((e) => 
			{
				if (values.includes(e.value)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
		}
		
		return temp;
	};

	const onSaveUserQuestionary= () => {
		UserProfileQuestionaryAnswers={};
		getUserProfileQuestionaryAnswers(UserProfileQuestionaryData,null,true);

		if(UserProfileQuestionaryAnswers["3"]==="No"&&!UserProfileQuestionaryAnswers["4"])
		{
			toast("Not engagement reason is required..", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
		else
		{
			var payload={
				nUserId:nUserId,
				nResourceInstanceId:nResourceInstanceIdForUserProfile,
				data:UserProfileQuestionaryAnswers
			}
			let xyz=payload;
		updateUserQuestionnaireData(payload);
		}
	}
	const onSaveBusinessQuestionary = () => {
		BusinessProfileQuestionaryAnswers={};
		BuisnessProfileMetaData = {}
		getBusinessProfileQuestionaryAnswers(BusinessProfileQuestionaryData,null,true);		
		var payload={
			nUserId:nUserId,
			sBusinessId:selectedUserBusinessOption,
			nResourceInstanceId:nResourceInstanceIdForUserProfile,
			sBusinessName:(props.sBusinessNameForUserProfile),
			sSectorName:(props.sSectorNameForUserProfile),
			sEmailAddress: userEmailAddressForFeedback,
			data:BusinessProfileQuestionaryAnswers,
			metadata:BuisnessProfileMetaData

		}
		let xyz=payload;
		updateUserBusinessQuestionnaireData(payload);
	}

	const updateUserQuestionnaireData = (payload) => {
		try 
		{
			setLoading(true);
			api.updateUserQuestionaireData(payload).then((res) => {
				if(res.data.message)
				{
					toast(res.data.message, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
				else
				{
					toast("Data saved successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}			
				getUpdatedUserProfiles();
				api.getUserQuestionnaire({user_id: nUserId}).then((d) => {
					setUserProfileQuestionaryData(d.data.user);
				});
			});			
		}
		catch (error) 
		{
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} 
		finally 
		{
			setLoading(false);
		}
	}

	const updateUserBusinessQuestionnaireData = (payload) => {
		try 
		{
			setLoading(true);
			api.updateUserBusinessQuestionaireData(payload).then((res) => {
				if(res.data.message)
				{
					toast(res.data.message, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
				else
				{
					toast("Data saved successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}	
				
				getUpdatedUserProfiles();				
				api.getUserBusinessQuestionnaire({user_id: nUserId}).then((d) => {
					setUsersAllBusinessProfileQuestionaryData(d.data);
				});
			});
			
		}
		catch (error) 
		{
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} 
		finally 
		{
			setLoading(false);
		}
	}

	const getUserProfileQuestionaryAnswers = (QestionArray,ParentField,isParentAnsCorrect) => {
		const Fields = QestionArray.map((field) => {
			if(field.bIsDependent)
			{
				if(ParentField)
				{
					if(isParentAnsCorrect&&ParentField.UserAnswer===field.sDependentAnswer)
					{
						//UserProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
						UserProfileQuestionaryAnswers={...UserProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
						getUserProfileQuestionaryAnswers(field.DependQuestions,field,true);
					}
					else
					{
						//UserProfileQuestionaryAnswers.push({[field.id]:null});
						UserProfileQuestionaryAnswers={...UserProfileQuestionaryAnswers,[field.id]:null};
						getUserProfileQuestionaryAnswers(field.DependQuestions,field,false);
					}
				}
				else
				{
					//UserProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
					UserProfileQuestionaryAnswers={...UserProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
					getUserProfileQuestionaryAnswers(field.DependQuestions,field,true);
				}				
			}
			else
			{
				if(ParentField)
				{
					if(isParentAnsCorrect&&ParentField.UserAnswer===field.sDependentAnswer)
					{
						//UserProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
						UserProfileQuestionaryAnswers={...UserProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
					}
					else
					{
						//UserProfileQuestionaryAnswers.push({[field.id]:null});
						UserProfileQuestionaryAnswers={...UserProfileQuestionaryAnswers,[field.id]:null};
					}
				}
				else
				{
					//UserProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
					UserProfileQuestionaryAnswers={...UserProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
				}
			}
		});
	}

	const getBusinessProfileQuestionaryAnswers = (QestionArray,ParentField,isParentAnsCorrect) => {
		const Fields = QestionArray.map((field) => {
			if(field.bIsDependent)
			{
				if(ParentField)
				{
					if(isParentAnsCorrect&&ParentField.UserAnswer===field.sDependentAnswer)
					{
						//BusinessProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
						BusinessProfileQuestionaryAnswers={...BusinessProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
						BuisnessProfileMetaData={...BuisnessProfileMetaData,[field.sName]:field.UserAnswer};
						getBusinessProfileQuestionaryAnswers(field.DependQuestions,field,true);
					}
					else
					{
						//BusinessProfileQuestionaryAnswers.push({[field.id]:null});
						BusinessProfileQuestionaryAnswers={...BusinessProfileQuestionaryAnswers,[field.id]:null};
						BuisnessProfileMetaData={...BuisnessProfileMetaData,[field.sName]:null};
						getBusinessProfileQuestionaryAnswers(field.DependQuestions,field,false);
					}
				}
				else
				{
					//BusinessProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
					BusinessProfileQuestionaryAnswers={...BusinessProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
					BuisnessProfileMetaData={...BuisnessProfileMetaData,[field.sName]:field.UserAnswer};
					getBusinessProfileQuestionaryAnswers(field.DependQuestions,field,true);
				}				
			}
			else
			{
				if(ParentField)
				{
					if(isParentAnsCorrect&&ParentField.UserAnswer===field.sDependentAnswer)
					{
						//BusinessProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
						BusinessProfileQuestionaryAnswers={...BusinessProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
						BuisnessProfileMetaData={...BuisnessProfileMetaData,[field.sName]:field.UserAnswer};
					}
					else
					{
						//BusinessProfileQuestionaryAnswers.push({[field.id]:null});
						BusinessProfileQuestionaryAnswers={...BusinessProfileQuestionaryAnswers,[field.id]:null};
						BuisnessProfileMetaData={...BuisnessProfileMetaData,[field.sName]:null};
					}
				}
				else
				{
					//BusinessProfileQuestionaryAnswers.push({[field.id]:field.UserAnswer});
					BusinessProfileQuestionaryAnswers={...BusinessProfileQuestionaryAnswers,[field.id]:field.UserAnswer};
					BuisnessProfileMetaData={...BuisnessProfileMetaData,[field.sName]:field.UserAnswer};
				}
			}
		});
	}

	//Facilitator Engagement callbacks end

	const onSendFeedbackSMS = async () => {
		try 
		{
			setLoading(true);
			if(nResourceInstanceIdForUserProfile) 
			{
				var payload={nResourceInstanceId:nResourceInstanceIdForUserProfile}
				let s=payload;
				const { data: _ignore_ } = await api.sendFeedbackLinkToUser(payload);
				toast("Feedback link sent to user successfully.", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
		} 
		catch (error) 
		{
			toast("Something went wrong. Contact webadmin support.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} 
		finally 
		{		
			setLoading(false);
		}
	};

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="user-profile-modal">
				<div className="p-2 modals-headers-bar">
					<span>User Profile </span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={props.toggleModal}
					>
						<X color="white" />
					</button>
				</div>
				<div className={`modal-body ${isLoading && "set-opacity"}`}>
					<div className="row">
						<div className="col-md-3 user-profile-section">
							<>{nUserId ? renderUserFields() : ""}</>
							{/*nResourceInstanceIdForUserProfile ? (<>
								<Button onClick={onSendClaimFreeListingSMS}>
									Send Claim Free Listing SMS
								</Button>
								<br></br>
								<br></br>
								</>
							) : (
								""
							)*/}
							
							{nUserId ? (
								<a
									href={`/home/three-sixty-degree-view?email=${userEmailAddressForFeedback}`}
									target="_blank"
									style={{marginRight:"10px"}}
								>
									To 360 degree view
								</a>
							) : (
								""
							)}

							{nUserId ? (
								<Button onClick={onSaveUserProfile}>
									Save
								</Button>
							) : (
								<Button onClick={onCreateUserProfile}>
									Create User Profile
								</Button>
							)}

							{/*
								sCurrentServiceRequestStateForUserProfile&&sCurrentServiceRequestStateForUserProfile=="Delivered"&&userServiceFeedbackData&&userServiceFeedbackData.length==0?
								(
									<Button onClick={onSendFeedbackSMS}
										style={{marginRight:"10px",marginTop:"10px"}}>
										Send Feedback Link
									</Button>
								):
								(
									""
								)*/
							}

							<div>
								<br></br>
								{nUserId ? (
									<Button onClick={toggleAdditionalDataModal}>
										Impact Metrics Data
									</Button>
								) : (
									""
								)}
							</div>
							<div>
								<br></br>
								{nUserId ? (
									<Button onClick={toggleSupportedDataModal}>
										Supported Status Change History
									</Button>
								) : (
									""
								)}
							</div>
							<div>
								<br></br>
								{nUserId ? (
									<Button
										onClick={toggleChangeEmailHistoryModal}
									>
										Email Change/User Merge History
									</Button>
								) : (
									""
								)}
							</div>
							<div>
								<br></br>
								{nUserId ? (
									<Button onClick={toggleUserMetaChangeLog}>
										User Meta Change Log
									</Button>
								) : (
									""
								)}
							</div>
						</div>

						
						<div className="col-md-9">
							{
								isFacilitatorEngagementView?
								(
									<>
									<div style={{float:"right"}}>
											{nResourceInstanceIdForUserProfile ? (
												<Button onClick={toggleFacilitatorEngagementView}>
													Back
												</Button>
											) : 
											(
												""
											)}
										</div>
										<div style={{clear:"both"}}></div>
										{renderFacilitatorEngagement()}
									</>
								):
								(
									<>
										<div style={{float:"right"}}>
											{nResourceInstanceIdForUserProfile ? (
												<Button onClick={toggleFacilitatorEngagementView}>
													Engagement
												</Button>
											) : 
											(
												""
											)}
										</div>
										<div style={{clear:"both"}}></div>
										{renderBusinessProfiles()}
									</>
								)
							}
						</div>
					</div>
					<UserMetaChangeLogModal
						isOpen={showUserMetaChangeLog}
						toggleModal={toggleUserMetaChangeLog}
						nUserId={props.nUserId}
						userMetaChangeLogData={userMetaChangeLogData}
					></UserMetaChangeLogModal>
					<UserProfileSupportedDataModal
						isOpen={showAdditionalDataModal}
						toggleModal={toggleAdditionalDataModal}
						additionalData={userProfileData["additional_data"]}
					></UserProfileSupportedDataModal>

					<UserProfileSupportedStatusHistoryDataModal
						isOpen={showSupportedDataModal}
						toggleModal={toggleSupportedDataModal}
						nUserId={props.nUserId}
						sEmailAddress={sEmailAddress}
					></UserProfileSupportedStatusHistoryDataModal>

					<UserProfileChangeEmailHistory
						isOpen={showChangeEmailHistoryModal}
						toggleModal={toggleChangeEmailHistoryModal}
						listEmailIdChangeHistory={
							userProfileData["additional_data"]
						}
					></UserProfileChangeEmailHistory>
					{
						showServiceFeedbackModal&&
						(
							<UserServiceFeedbackModal
								isOpen={showServiceFeedbackModal}
								toggleModal={toggleServiceFeedbackModal}
								sEmailAddress={userEmailAddressForFeedback}
								nResourceInstanceId={null}
								nUserId={nUserId}
							>
							</UserServiceFeedbackModal>
						)
					}
					{isLoading && <Spinner className="top" />}
				</div>
			</ModalContent>
		</Modal>
	);
}

const BusinessProfile = ({ businessProfile, businessIndex, ...props }) => {

	const getMultiSelectedItem = (Options,values) => {
		let temp =[];
		if(values)
		{
			let tempSR = Options.map((e) => 
			{
				if (values.includes(e.value)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
		}
		
		return temp;
	};

	if (
		businessProfile["sBusinessName"] === null &&
		businessProfile["sBusinessSector"] === null
	) {
		return <div></div>;
	}
	let yOfEstd = businessProfile["nYearOfEstablishment"];
	let selectedYearOfEstd;
	if (yOfEstd !== null) {
		selectedYearOfEstd = new Date(String(yOfEstd));
	}
	let selectedTypeOfOrg = props.TYPE_OF_ORG_DROPDOWN_VALUES.filter(
		(e) => businessProfile["sTypeOfOrganization"] === e.value
	);
	let selectedTypeOfBusiness = props.SELECT_BUSINESS_TYPE_VALUES.filter(
		(e) => businessProfile["sBusinessType"] === e.value
	);
	let selectedNatureoftheBusiness = props.NatureoftheBusinessOptions.filter(
		(e) => businessProfile["sBusinessNatures"] === e.value
	);
	let selectedBasicCompliances = getMultiSelectedItem(props.BasicCompliancesOptions, businessProfile["sBasicCompliances"]);
	
	const leftPanel = BUSINESS_PROFILE_FIELDS.map((field, index) => {
		if (index <= 5) {
			if (field.key === "sBusinessType") {
				return (
					<div style={{marginBottom: "1rem"}}>
						<label>{field.name}</label>
						<Select
							key={index}
							name={field.key}
							label={field.name}
							value={selectedTypeOfBusiness}
							options={props.SELECT_BUSINESS_TYPE_VALUES}
							onChange={(value) => {
								props.onInputChange(
									field.key,
									value.value,
									businessIndex
								);
							}}
						/>
					</div>
				);
			}
			if (field.key === "sTypeOfOrganization") {
				return (
					<div style={{marginBottom: "1rem"}}>
						<label>{field.name}</label>
						<Select
							key={index}
							name={field.key}
							label={field.name}
							value={selectedTypeOfOrg}
							options={props.TYPE_OF_ORG_DROPDOWN_VALUES}
							onChange={(value) => {
								props.onInputChange(
									field.key,
									value.value,
									businessIndex
								);
							}}
						/>
					</div>
				);
			}
			if (field.key === "sBusinessNatures") {
				return (
					<div style={{marginBottom: "1rem"}}>
						<label>{field.name}</label>
						<Select
							key={index}
							name={field.key}
							label={field.name}
							value={selectedNatureoftheBusiness}
							options={props.NatureoftheBusinessOptions}
							onChange={(value) => {
								props.onInputChange(
									field.key,
									value.value,
									businessIndex
								);
							}}
						/>
					</div>
				);
			}
			if (field.key === "sBasicCompliances") {
				return (
					<div style={{marginBottom: "1rem"}}>
						<label>{field.name}</label>
						<ReactMultiSelectCheckboxes
							key={index}
							name={field.sName}
							options={props.BasicCompliancesOptions}
							placeholderButtonLabel="Select.."
							value={selectedBasicCompliances}
							onChange={(value) => {
								props.onInputChange(
									field.key,
									value,
									businessIndex
								);
							}}
						/>
					</div>
				);
			}

			return (
				<div
					className={`${
						field.key === "sBusinessName" ||
						field.key === "sBusinessSector" ||
						field.key === "sCity" ||
						field.key === "sState" ||
						field.key === "sCountry"
							? "cursor-not-allowed"
							: ""
					}`}
				>
					<ControlledInput
						key={index}
						name={field.key}
						label={field.name}
						value={get(businessProfile, field.key) || ""}
						onChange={({ target }) => {
							props.onInputChange(
								field.key,
								target.value,
								businessIndex
							);
						}}
						className={`${
							field.key === "sBusinessName" ||
							field.key === "sBusinessSector" ||
							field.key === "sCity" ||
							field.key === "sState" ||
							field.key === "sCountry"
								? "disabled pointer-events-none"
								: ""
						}`}
					></ControlledInput>
				</div>
			);
		}
	});
	const middlePanel = BUSINESS_PROFILE_FIELDS.map((field, index) => {
		if (5 < index && index <= 9) {
			return (
				<div
					className={`${
						field.key === "sBusinessName" ||
						field.key === "sBusinessSector" ||
						field.key === "sCity" ||
						field.key === "sState" ||
						field.key === "sCountry"
							? "cursor-not-allowed"
							: ""
					}`}
				>
					<ControlledInput
						key={index}
						name={field.key}
						label={field.name}
						value={get(businessProfile, field.key) || ""}
						onChange={({ target }) => {
							props.onInputChange(
								field.key,
								target.value,
								businessIndex
							);
						}}
						className={`${
							field.key === "sBusinessName" ||
							field.key === "sBusinessSector" ||
							field.key === "sCity" ||
							field.key === "sState" ||
							field.key === "sCountry"
								? "disabled pointer-events-none"
								: ""
						}`}
					/>
				</div>
			);
		}
	});
	const rightPanel = BUSINESS_PROFILE_FIELDS.map((field, index) => {
		if (index > 9) {
			if (field.key === "nYearOfEstablishment") {
				return (
					<div>
						<span>Year of Establishment</span>
						<br></br>
						<ReactDatePicker
							selected={selectedYearOfEstd}
							showYearPicker
							dateFormat="yyyy"
							onChange={(date) => {
								props.onInputChange(
									field.key,
									date.getFullYear(),
									businessIndex
								);
							}}
						/>
						<br></br>
					</div>
				);
			}
			return (
				<div
					className={`${
						field.key === "sBusinessName" ||
						field.key === "sBusinessSector" ||
						field.key === "sCity" ||
						field.key === "sState" ||
						field.key === "sCountry"
							? "cursor-not-allowed"
							: ""
					}`}
				>
					<ControlledInput
						key={index}
						name={field.key}
						label={field.name}
						value={get(businessProfile, field.key) || ""}
						onChange={({ target }) => {
							props.onInputChange(
								field.key,
								target.value,
								businessIndex
							);
						}}
						className={`${
							field.key === "sBusinessName" ||
							field.key === "sBusinessSector" ||
							field.key === "sCity" ||
							field.key === "sState" ||
							field.key === "sCountry"
								? "disabled pointer-events-none"
								: ""
						}`}
					/>
				</div>
			);
		}
	});
	return (
		<div>
			<div className="row">
				<div className="col-md-6">{leftPanel}</div>
				<div className="col-md-6">
					<div className="row">
						<div className="col-md-6">{middlePanel}</div>
						<div className="col-md-6">{rightPanel}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const ResourceData = ({ resourceData, ...props }) => {
	if (Array.isArray(resourceData["ResourceData"])) {
		if (resourceData["ResourceData"].length) {
			return resourceData["ResourceData"].map((data, index) => {
				return (
					<>
						<b>{data["ResourceName"]}</b>
						<br></br>
						{moment(moment.utc(data["dtCreated"]).toDate()).format(
							"MMMM Do YYYY, h:mm:ss a"
						)}
						<br></br>
						<br></br>
					</>
				);
			});
		} else {
			return <span>No data to display</span>;
		}
	} else {
		return <span>No data to display</span>;

		// if (resourceData["ResourceData"]["ToolTemplates"].length) {
		// 	return resourceData["ResourceData"]["ToolTemplates"].map(
		// 		(data, index) => {
		// 			return (
		// 				<>
		// 					<b>{data["ResourceName"]}</b>
		// 					<br></br>
		// 					{moment(
		// 						moment.utc(data["dtCreated"]).toDate()
		// 					).format("MMMM Do YYYY, h:mm:ss a")}
		// 					<br></br>
		// 					<br></br>
		// 				</>
		// 			);
		// 		}
		// 	);
		// } else {
		// 	return <span>No data to display</span>;
		// }
	}
};

const ChecklistData = ({ checklistData, ...props }) => {
	if (Array.isArray(checklistData["ResourceData"])) {
		return <span>No data to display</span>;
	} else {
		if (checklistData["ResourceData"]["Checklists"].length) {
			return checklistData["ResourceData"]["Checklists"].map(
				(data, index) => {
					return (
						<>
							<b>{data["ResourceName"]}</b>
							<br></br>
							{moment(
								moment.utc(data["dtCreated"]).toDate()
							).format("MMMM Do YYYY, h:mm:ss a")}
							<br></br>
							<br></br>
						</>
					);
				}
			);
		} else {
			return <span>No data to display</span>;
		}
	}
};

const getServiceName = (original) => {
	if (!original) return;
	const found = find(getServiceTypesMaster(), {
		sServiceCode: original.sServiceCode,
	});
	if (found) {
		return found.sServiceName;
	}
	return "";
};

const isMovedToSPM = (original) => {
	if (!original) return;
	if (original.bMovedToSPM) {
		return "Yes";
	} else {
		return "No";
	}
};

const ServiceRequestsData = ({ serviceRequestData, ...props }) => {
	if (serviceRequestData["ServiceRequests"].length === 0)
		return <span>No data to display</span>;
	const rows = serviceRequestData["ServiceRequests"].map((data, index) => {
		return (
			<tr>
				<td>
					<sapn>{getServiceName(data)}</sapn>
				</td>
				<td>
					{moment(moment.utc(data["dtRequested"]).toDate()).format(
						"MMMM Do YYYY, h:mm:ss a"
					)}
				</td>
				<td>{data["refSRState"]}</td>
				<td>
					{data["existing_service_facilitator"]
						? data["existing_service_facilitator"]["email"]
						: ""}
				</td>
			</tr>
		);
	});
	return (
		<table>
			<tr>
				<th>Service Name</th>
				<th>Date Requested</th>
				<th>Status</th>
				<th>Facilitator</th>
			</tr>
			{rows}
		</table>
	);
};

const ServicesData = ({ serviceRequestData, ...props }) => {
	if (serviceRequestData["Services"].length === 0)
		return <span>No data to display</span>;
	const rows = serviceRequestData["Services"].map((data, index) => {
		return (
			<tr>
				<td>
					<sapn>{getServiceName(data)}</sapn>
				</td>
				<td>
					{moment(
						moment.utc(data["dtServiceProgression"]).toDate()
					).format("MMMM Do YYYY, h:mm:ss a")}
				</td>
				<td>
					{data["refCurrentState"]
						? data["refCurrentState"]["sServiceState"]
						: ""}
				</td>
				<td>
					{data["refFacilitator"]
						? data["refFacilitator"]["email"]
						: ""}
				</td>
			</tr>
		);
	});
	return (
		<table>
			<tr>
				<th>Service Name</th>
				<th>Date of Progression</th>
				<th>Status</th>
				<th>Facilitator</th>
			</tr>
			{rows}
		</table>
	);
};
